export const SET_COUNTRIES = "SET_COUNTRIES";
export const SET_CITIES = "SET_CITIES";
export const SET_SECTIONS = "SET_SECTIONS";

export const setCountries = (countries: string[]) => ({
	type: SET_COUNTRIES,
	payload: countries,
});

export const setCities = (cities: string[]) => ({
	type: SET_CITIES,
	payload: cities,
});

export const setSections = (zones: string[]) => ({
	type: SET_SECTIONS,
	payload: zones,
});
